<template>
  <div className="wrapper">
    <div className="header_wrapper">
      <h1 className="title_wrapper">
        사용 내역 조회
      </h1>
    </div>


    <div>
      <div
          v-for="(value, name) in inputData"
          :key="name"
          class="li"
      >
        <Input
            v-if="inputData[name].type === 'text'"
            v-model="userData[name]"
            :label="name"
            :is-disabled="inputData[name].isDisabled"
        />
      </div>
    </div>
    <div class="d-flex justify-end">
      <div class="total-box">
        <div class="total-label">Total</div>
        <input class="total-value" type="text" :value="totalCount" readonly />
      </div>
    </div>
    <v-app>


      <v-data-table
          class="elevation-1"
          :headers="[...headers]"
          :items="dataList"
          :hide-default-footer="true"
          :server-items-length="dataList.length"
      />
      <Pagination/>
      <Excel @click="fetchExcelFile"/>
    </v-app>
  </div>
</template>

<script>
import GamesetCard from "@/components/gameset/GamesetCard"
import Input from "@/components/common/formControls/Input"
import {MENU, CATEGORY,} from "@/constants/mapVarNames"
import CreateButton from "@/components/common/buttons/CreateButton"
import table from "@/mixins/table"
import excel from "@/mixins/excel"
import param from "@/mixins/param"
import {getCurrentDate,} from "@/utils/date"
import {getExcelDataBySurveyId, getGameByHistory, getGameByUse,} from "@/api/exportExcel"

export default {
  components: {
    Input,
    CreateButton,
  },
  mixins: [table, excel, param],
  data() {
    return {
      totalCount: 0,
      cardData: {},
      surveyHeaders: [],
      headers: [
        {
          class: "table_header_xs",
          text: "게임 세트 종료일",
          value: "gameset.valid_until",
          sortable: false,
        },
        {
          class: "table_header_xs",
          text: "게임 세트명",
          value: "gameset.name",
          sortable: false,
        },
        {
          class: "table_header_xs",
          text: "사용 내역(건)",
          value: "use_count",
          sortable: false,
        },

      ],
      surveyId: this.$route.params.id,
      userData: {
        id: "",
        username: "",
        name: "",
      },
      inputData: {
        id: {
          type: "text",
          isDisabled: true,
        },
        username: {
          type: "text",
          isDisabled: true,
        },
        name: {
          type: "text",
          isDisabled: false,
        },
      },
    }
  },
  computed: {
    curItem() {
      return this.$store.state.lookup.game.currentItem
    },
  },
  mounted() {
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', this.onBrowserBack);
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.onBrowserBack);
  },

  methods: {
    async init() {
      console.log("username:", this.curItem.username)
      console.log("company:",  this.curItem.company_name)
      this.userData.id = this.$route.params.id
      this.userData.username = this.curItem.username
      this.userData.name = this.curItem.company_name

      this.$store.commit("SET_LOOKUP_CATEGORY", { menu: MENU.game, category: CATEGORY.use, })
      this.$store.commit("SET_FILTER_OPTIONS", {
        item:  "user_id",
        value: this.$route.params.id
      })
      await this.$store.dispatch("fetchLookupData")
      console.log(this.dataList)
      let temp = 0
      for (let i = 0; i < this.dataList.length; i++) {
        temp += this.dataList[i].use_count
      }
      this.totalCount = temp
    },


    onBrowserBack() {
      // 뒤로가기를 누르면 gameBuy 라우트로 이동
      this.$router.replace({ name: 'gameBuy' });
    },

    handleSetSurveyProps() {
      const surveyQuestions = this.survey.questions
      const surveyPropsHeader = surveyQuestions.map((item, index) => {
        return {
          class: "table_header_lg",
          text: item,
          value: `answers[${index}]`,
          sortable: false,
        }
      })

      this.surveyHeaders = [...surveyPropsHeader]
    },

    handleInput() {

    },


    async fetchExcelFile(test) {
      try {
        // 1) API 호출해서 JSON 가져오기
        console.log(this.$route.params.id)
        const resp = await getGameByUse({ id: this.$route.params.id })
        const data = resp.data.data
        if (!data.length) {
          alert("내역이 없습니다.")
          return
        }

        // 2) CSV 문자열 생성
        const keys = [
          "gameset.valid_until",
          "gameset.name",
          "use_count",
          "purchase_at"
        ]
        // 2) 키 배열에 대응하는 헤더 라벨 배열
        const headerLabels = [
          "게임 세트 종료일",
          "게임 세트명",
          "사용 내역(건)",
        ]
        const headerRow = headerLabels.join(",") + "\r\n"

        // 3) 중첩 path 로부터 값 추출하는 헬퍼
        const getValue = (obj, path) =>
            path.split(".").reduce((o, key) => (o == null ? "" : o[key]), obj)

        // 4) 본문 rows 생성
        const bodyRows = data
            .map(row =>
                keys
                    .map(k => {
                      const val = getValue(row, k)
                      // CSV용으로 escape
                      return `"${String(val ?? "").replace(/"/g, '""')}"`
                    })
                    .join(",")
            )
            .join("\r\n")

        // 5) BOM + CSV
        const csv = "\uFEFF" + headerRow + bodyRows

        // 6) Blob → 다운로드
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
        const url  = URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href     = url
        link.download = `사용내역_${this.$route.params.id}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (error) {
        this.$store.dispatch("setError", error)
      }
    },
  },
}
</script>

<style scoped>
.total-box {
  display: inline-flex;
  font-family: sans-serif;
  font-size: 14px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ccc;
  height: 36px;       /* 전체 높이 */
}

.total-label {
  background-color: #000;
  color: #fff;
  width: 87px;        /* label 너비 */
  display: flex;
  align-items: center;
  justify-content: flex-start;  /* 왼쪽 정렬 */
  padding: 0 12px;    /* 좌우 패딩 */
  box-sizing: border-box;
  height: 100%;
}

.total-value {
  border: none;
  width: 94px;        /* input 너비 */
  height: 100%;       /* 부모 높이에 맞춤 */
  padding: 0 12px;    /* 좌우 패딩 */
  text-align: left;
  background-color: #fff;
  outline: none;
  border-radius: 0 4px 4px 0;
  box-sizing: border-box;
}
</style>
